import { Link } from "react-router-dom";
import "./RegPulseSignupActivation.css";

const RegPulseSignupActivation = () => {
  return (
    <section className="regpulse-success-page">
      <div className="regpulse-success-content">
        <div className="regpulse-success-icon">✓</div>

        <p className="regpulse-success-eyebrow">EvoNext RegPulse</p>

        <h1>You’re on the list.</h1>

        <p className="regpulse-success-message">
          Your email has been verified. You're set. From now on, we'll send you a daily update whenever
           something new comes up - nothing to check, nothing to miss.
        </p>

        <Link to="/home" className="regpulse-success-back">
          ← Back to www.evonext.ai
        </Link>
      </div>
    </section>
  );
};

export default RegPulseSignupActivation;